import { FC, memo } from 'react';
import { TimeScale, TimeScaleProps } from './TimeScale';
import { Slider, SliderProps } from './Slider';
import { Box } from 'theme-ui';
import { formatTime } from 'utils/formatTime';
import { useTranslator } from '@picsart/rc/services/localization';

export type TimeSliderProps = SliderProps & Pick<TimeScaleProps, 'pointsCount'>;

export const TimeSlider: FC<TimeSliderProps> = memo(
  ({ min = 0, max, value, pointsCount, className, ...props }) => {
    const translator = useTranslator();
    const tooltip = formatTime(value, translator);
    return (
      <Box pt={6} className={className}>
        <Slider min={min} max={max} value={value} tooltip={tooltip} step={100} {...props} />
        <TimeScale min={min} max={max} pointsCount={pointsCount} sx={{ mt: 1 }} />
      </Box>
    );
  }
);
